import { cn } from "@/lib/utils";
import { type VariantProps, cva } from "class-variance-authority";
import * as React from "react";

const badgeVariants = cva(
  "inline-flex items-center rounded-full border text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-primary text-primary-foreground hover:opacity-80",
        primary2:
          "border-transparent bg-primary-0.5 text-primary hover:opacity-80",
        secondary:
          "border-transparent bg-secondary text-secondary-foreground hover:opacity-80",
        destructive:
          "border-transparent bg-destructive text-destructive-foreground hover:opacity-80",
        outline: "text-foreground",
      },
      size: {
        default: "px-2.5 py-0.5",
        sm: "h-5 min-w-5 p-1 justify-center",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  },
);

export type BadgeVariant = VariantProps<typeof badgeVariants>["variant"];

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, size, ...props }: BadgeProps) {
  return (
    <div
      className={cn(badgeVariants({ variant, size }), className)}
      {...props}
    />
  );
}

export { Badge, badgeVariants };
